// 产品列表

import { useState, useEffect, } from 'react'
import fun from './../../common/common_fun'
import url from './../../common/url_config'
import huijv from './../../common/huijv'
import { Spin, Button, Tag, Drawer, Table, Select, DatePicker, message, Modal, Switch, Input, Popover } from 'antd'
import 'moment/locale/zh-cn';
import { LoadingOutlined, TeamOutlined, UnorderedListOutlined, MenuOutlined, StepForwardOutlined, DownOutlined, UpOutlined, DesktopOutlined } from '@ant-design/icons';
import Menu from '../../components/menu'
import product from '../../img/product.png'
import cookie from 'react-cookies'
import common_data from './../../common/common_data'
import ModifyInfo from '../../components/modify_info'
import common_fun from './../../common/common_fun'
import screen_png from '../../img/screen.png'
import camera_png from '../../img/camera.png'

function App(props: any) {
  let [loading, set_loading] = useState(false)//加载中
  let [data, set_data] = useState([{
    cpu_family: '',
    title: '',
    id: 1,
    img_href: '',
    board_set: [],
  }])//产品列表数据
  let [data_show, set_data_show] = useState([{
    cpu_family: '',
    title: '',
    id: 1,
    img_href: '',
    board_set: [],
    show_all: false,
  }])//产品列表数据（显示）
  let [draw_visible, set_draw_visible] = useState(false)//抽屉展示
  let [visible, set_visible] = useState(false)//预定遮罩
  let [start_date, set_start_date] = useState(fun.formatDate(new Date()))
  let [order_start_h, set_order_start_h] = useState('')
  let [order_start_m, set_order_start_m] = useState('')
  let [order_end_h, set_order_end_h] = useState('')
  let [order_end_m, set_order_end_m] = useState('')
  let [board_set, set_board_set] = useState([])//当前预定其他时间得开发板集合
  let [order_time_index_set, set_order_time_index_set] = useState([])//预定得时间集合 
  let [current_cpu_family, set_current_cpu_family] = useState('')//参数中的cpu_family参数
  let [show_availab_only, set_show_availab_only] = useState(false)//仅显示可用开发板
  let [current_product_category, set_current_product_category] = useState('')//参数中的product_category参数 
  let [current_product_line, set_current_product_line] = useState('')//参数中的product_line参数
  let [filter_board_name, set_filter_board_name] = useState('')//筛选开发板名称
  let [categories_set, set_categories_set] = useState([])//product_line集合
  let [my_co_info, set_my_co_info] = useState({})//完善企业信息
  let [visible_my_info, set_visible_my_info] = useState(false)//完善企业信息遮罩
  let [current_language_ch, set_current_language_ch] = useState(window.location.href.indexOf('?lan=en') === -1)//当前语言是否中文   
  let [current_height, set_current_height] = useState(document.documentElement.clientHeight)//当前页面高度

  // 查询是否可以预定
  const confirm_order = () => {
    if (board_set.length === 0) {
      message.error(current_language_ch ? '请选择开发板CPU！' : "Please choose board's CPU!")
      return
    }
    if (!start_date) {
      message.error(current_language_ch ? '请选择预定日期！' : 'Please choose book date!')
      return
    }
    let order_date = [{ "h": 0, "m": 0 }, { "h": 0, "m": 15 }, { "h": 0, "m": 30 }, { "h": 0, "m": 45 }, { "h": 1, "m": 0 }, { "h": 1, "m": 15 }, { "h": 1, "m": 30 }, { "h": 1, "m": 45 }, { "h": 2, "m": 0 }, { "h": 2, "m": 15 }, { "h": 2, "m": 30 }, { "h": 2, "m": 45 }, { "h": 3, "m": 0 }, { "h": 3, "m": 15 }, { "h": 3, "m": 30 }, { "h": 3, "m": 45 }, { "h": 4, "m": 0 }, { "h": 4, "m": 15 }, { "h": 4, "m": 30 }, { "h": 4, "m": 45 }, { "h": 5, "m": 0 }, { "h": 5, "m": 15 }, { "h": 5, "m": 30 }, { "h": 5, "m": 45 }, { "h": 6, "m": 0 }, { "h": 6, "m": 15 }, { "h": 6, "m": 30 }, { "h": 6, "m": 45 }, { "h": 7, "m": 0 }, { "h": 7, "m": 15 }, { "h": 7, "m": 30 }, { "h": 7, "m": 45 }, { "h": 8, "m": 0 }, { "h": 8, "m": 15 }, { "h": 8, "m": 30 }, { "h": 8, "m": 45 }, { "h": 9, "m": 0 }, { "h": 9, "m": 15 }, { "h": 9, "m": 30 }, { "h": 9, "m": 45 }, { "h": 10, "m": 0 }, { "h": 10, "m": 15 }, { "h": 10, "m": 30 }, { "h": 10, "m": 45 }, { "h": 11, "m": 0 }, { "h": 11, "m": 15 }, { "h": 11, "m": 30 }, { "h": 11, "m": 45 }, { "h": 12, "m": 0 }, { "h": 12, "m": 15 }, { "h": 12, "m": 30 }, { "h": 12, "m": 45 }, { "h": 13, "m": 0 }, { "h": 13, "m": 15 }, { "h": 13, "m": 30 }, { "h": 13, "m": 45 }, { "h": 14, "m": 0 }, { "h": 14, "m": 15 }, { "h": 14, "m": 30 }, { "h": 14, "m": 45 }, { "h": 15, "m": 0 }, { "h": 15, "m": 15 }, { "h": 15, "m": 30 }, { "h": 15, "m": 45 }, { "h": 16, "m": 0 }, { "h": 16, "m": 15 }, { "h": 16, "m": 30 }, { "h": 16, "m": 45 }, { "h": 17, "m": 0 }, { "h": 17, "m": 15 }, { "h": 17, "m": 30 }, { "h": 17, "m": 45 }, { "h": 18, "m": 0 }, { "h": 18, "m": 15 }, { "h": 18, "m": 30 }, { "h": 18, "m": 45 }, { "h": 19, "m": 0 }, { "h": 19, "m": 15 }, { "h": 19, "m": 30 }, { "h": 19, "m": 45 }, { "h": 20, "m": 0 }, { "h": 20, "m": 15 }, { "h": 20, "m": 30 }, { "h": 20, "m": 45 }, { "h": 21, "m": 0 }, { "h": 21, "m": 15 }, { "h": 21, "m": 30 }, { "h": 21, "m": 45 }, { "h": 22, "m": 0 }, { "h": 22, "m": 15 }, { "h": 22, "m": 30 }, { "h": 22, "m": 45 }, { "h": 23, "m": 0 }, { "h": 23, "m": 15 }, { "h": 23, "m": 30 }, { "h": 23, "m": 45 }, { "h": 0, "m": 0 }]
    let order_time_index_set: any = fun.appoint_time(start_date, order_date, order_start_h, order_start_m, order_end_h, order_end_m)
    if (!order_time_index_set) {
      return
    }
    set_order_time_index_set(order_time_index_set)
    console.log('预定index', order_time_index_set)

    set_loading(true)
    fun['post_data'](url + 'appointment_watch', {
      only_check: true,
      start_date, board_name_set: board_set.map((item: any) => item['name']), order_time_index_set,
    }).then(res => {
      if (res.status) {
        console.log(res.result)
        let temp: any = board_set.map((item: any, index: number) => ({
          ...item,
          status: res.result[index]['status'] && item.lab_state === 'active'
        }))
        set_board_set(temp)
        console.log(temp)
      } else {
        alert(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
      }
      set_loading(false)
    })
  }

  const get_data = (product_line: string, product_category: string, cpu_family: string, key_word = '') => {
    if (product_line === 'all') {
      fun['post_data'](url + 'get_boards_product_line_menu', {}).then(res => {
        if (res.status) {
          console.log('产品页面查询分类数据', res.result)
          set_categories_set(res.result)
        } else {
          message.error(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
        }
      })
    }

    set_loading(true)
    const params = {
      key_word, product_line, product_category, cpu_family,
      time_zone_offset_hours: common_data.time_zone_offset_hours,
    }
    console.log('请求参数', params)
    fun['post_data'](url + 'get_boards_list_by_cpu_family_new_with_format_url', params).then(res => {
      if (res.status) {
        console.log('查询多条数据', res.result)
        set_data(res.result)
        set_data_show(res.result.map((item: any) => ({
          ...item,
          show_all: false,
        })))

        // 查找product_line
        if (product_category && res.result.length > 0) {
          let temp_board_set = res.result[0]['board_set']
          if (temp_board_set.length > 0) {
            set_current_product_line(temp_board_set[0]['product_line'])
          }
        }
      } else {
        message.error(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
      }
      set_loading(false)
    })
  }

  useEffect(() => {
    console.log('porps集合', props.product_line, props.product_category, props.cpu_family)

    // 初始化
    set_current_cpu_family('')//三级分类
    set_current_product_category('')//二级分类
    set_current_product_line('')//一级分类
    let temp_title = ''//临时标题

    if (props.product_category === 'all') {
      // 根据product_line查询
      set_current_product_line(props.product_line)
      get_data(props.product_line, '', '')

      temp_title = props.product_line
    } else {
      // 根据product_category查询
      set_current_product_category(props.product_category)
      set_current_cpu_family(props.cpu_family)
      get_data('', props.product_category, props.cpu_family)
      // get_data参数：product_line: string, product_category: string, cpu_family: string

      temp_title = props.cpu_family || props.product_category
    }
    set_draw_visible(false)

    // // 荟聚
    huijv.open_page({
      "targetName": "产品列表页" + temp_title,
      "targetId": 'product_list',
    })

    window.addEventListener('resize', (e: any) => {
      set_current_height(document.body.clientHeight)
    })

    setTimeout(() => {
      let temp = document.getElementsByClassName('product_list_page_content')
      console.log(temp[0])
    }, 1000 * 3)
  }, [window.location.href])

  return <div style={{ minHeight: current_height - 160 }}>
    {/* 完善企业信息遮罩 */}
    <Modal width={500} destroyOnClose style={{ top: 10 }} visible={visible_my_info} footer={false} onCancel={() => { set_visible_my_info(false) }}>
      <ModifyInfo close_modal={() => { set_visible_my_info(false) }} my_co_info={my_co_info} />
    </Modal>

    {/* 预定其他时间遮罩 */}
    <Modal width={650} style={{ top: 10 }} visible={visible} title={common_data.select_book_date_title} footer={false} onCancel={() => set_visible(false)}>
      <div>
        <Select placeholder={common_data.select_book_date_ipt} style={{ width: 300, marginRight: 10 }} onChange={(e: any) => {
          set_start_date(e)
        }}>
          {fun.render_date_option().map((item: any) => <Select.Option key={item} value={item}>{item}</Select.Option>)}
        </Select>

        <div style={{ marginTop: 10 }}>
          <Select style={{ width: 240, marginRight: 10 }} placeholder={current_language_ch ? '开始(时)' : 'START HOUR'} onChange={(e: any) => {
            set_order_start_h(e)
          }} options={common_fun.render_h_picker(start_date === fun.formatDate(new Date()) ? new Date().getHours() : 0)} />
          <Select style={{ width: 240, }} placeholder={current_language_ch ? '开始(分)' : 'START MINUTE'} onChange={(e: any) => set_order_start_m(e)} options={common_fun.render_m_picker} />
        </div>
        <div style={{ marginTop: 10 }}>
          <Select style={{ width: 240, marginRight: 10 }} placeholder={current_language_ch ? '结束(时)' : 'END HOUR'} onChange={(e: any) => set_order_end_h(e)} options={([{ label: current_language_ch ? '当日结束' : 'Day Ended', value: '当日结束 / Day Ended' }]).concat(common_fun.render_h_picker(order_start_h === '' ? 0 : Number(order_start_h)))} />
          {order_end_h !== '当日结束 / Day Ended' && <Select style={{ width: 240, }} placeholder={current_language_ch ? '结束(分)' : 'END MINUTE'} onChange={(e: any) => set_order_end_m(e)} options={common_fun.render_m_picker} />}
        </div>
        <Button onClick={() => {
          if ((new Date(start_date).getTime() - new Date().getTime()) / (60000 * 60) > 192) {
            message.error(common_data.book_mention_1)
            return
          }
          if (start_date < fun.formatDate(new Date())) {
            message.error(current_language_ch ? '请选择正确的日期' : 'Please select the correct date !')
            return
          }
          confirm_order()
        }} loading={loading} type='primary' style={{ marginTop: 10, }}>{current_language_ch ? '选择预定日期、开始和结束时间后 点击查询' : 'Click to query after selected the book date and times'}</Button>
      </div>
      <div style={{ marginTop: 10 }}>
        {current_language_ch ? <div>
          <div>1、选择预定日期（不选则表示今日）</div>
          <div>2、选择开始时间和结束时间（注意小时和分钟都要选）</div>
          <div>3、点击查询，在下面开发板列表中选择可使用的开发板</div>
          <div>4、点击开发板名称，确认预定</div>
          <div><b>5、{common_data.book_mention_1}</b></div>
          <div><b>6、{common_data.book_mention_2}</b></div>
          <div><b>7、{common_data.book_mention_3}</b></div>
        </div> : <div>
          <div>1. Select appointment date (if not selected, it indicates the today)</div>
          <div>2. Select start and end times (note to select both hours and minutes)</div>
          <div>3. Click on the query and select the available boards from the board list below</div>
          <div>4. Click on the board name to confirm the reservation</div>
          <div><b>5. {common_data.book_mention_1}</b></div>
          <div><b>6. {common_data.book_mention_2}</b></div>
          <div><b>7. {common_data.book_mention_3}</b></div>
        </div>}
      </div>
      <div style={{ marginTop: 10 }}>
        {board_set.map((item: any, index: number) => <div onClick={() => {
          if (loading) {
            return
          }
          if (item.status) {
            if ((new Date(start_date).getTime() - new Date().getTime()) / (60000 * 60) > 192) {
              message.error(common_data.book_mention_1)
              return
            }
            if (start_date < fun.formatDate(new Date())) {
              message.error(current_language_ch ? '请选择正确的日期' : 'Please select the correct date !')
              return
            }

            if (window.confirm(current_language_ch ? '确认预定' : 'Confirm Book')) {
              huijv.c_cloud_lab_website_board_order(item['cpu_family'], item.name, { start_date, order_start_h, order_start_m, order_end_h, order_end_m })

              set_loading(true)
              fun['post_data'](url + 'appointment_watch', {
                start_date, board_name: item.name, order_time_index_set,
                is_from_now: order_start_h === '现在开始 / From Now',
                board_category: item['product_category'],
                board_type: item['type'],
                board_cpu_family: item['cpu_family'],
              }).then(res => {
                if (res.status) {
                  set_visible(false)
                  if (window.confirm(common_data.book_fuccessful_mention)) {
                    window.location.href = '/my' + (current_language_ch ? '' : '?lan=en')
                  }
                } else {
                  alert(current_language_ch ? ('预定失败：' + JSON.stringify(res.result)) : ('Book Failed: ' + JSON.stringify(res.result_en)))
                }
                set_loading(false)
              })
            }
          }
        }} style={{ marginBottom: 5, cursor: 'pointer' }} key={index}>
          {item.status !== undefined && <div>
            {!item.status ? <Tag style={{ width: 90, textAlign: 'center' }} color={'#f50'}>{current_language_ch ? '不可用' : 'Unavailable'}</Tag> : <Tag style={{ width: 90, textAlign: 'center' }} color={'#69CA00'}>{current_language_ch ? '可使用' : 'Available'}</Tag>}
            <b>{item.name_no_num}</b> <i>#{item.num}</i>
          </div>}
        </div>)}
      </div>
    </Modal>

    {/* 左侧菜单 */}
    {!common_data.isMobile ? <div style={{
      width: 320, float: 'left',
      height: current_height - 70, overflowY: 'auto', position: 'fixed', left: 0,
    }}><Spin spinning={loading}><Menu /></Spin></div> : <><div style={{ textAlign: 'left' }}><Button icon={<UnorderedListOutlined />} onClick={() => set_draw_visible(true)}>CPU {current_language_ch ? '菜单' : 'MENU'}</Button></div><Drawer title={'MENU'} width={250} onClose={() => set_draw_visible(false)} visible={draw_visible}><Menu /></Drawer></>}

    <div className='product_list_page_content' style={{ width: common_data.isMobile ? '100%' : 'calc(100% - 330px)', float: 'right', }} >
      <div style={{ fontSize: 15, lineHeight: '20px', paddingTop: 10, marginLeft: '1%' }}>{current_language_ch ? "预定您想了解的恩智浦开发板" : "Choose any of the NXP evaluation kits avaliable to start virtual testing."} </div>
      {/* 面包屑导航 */}
      <h3 className='nav_bread_box' style={{
        width: '98%', margin: '5px auto 10px', color: '#8b8b8b', fontWeight: 'normal',
        alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div className='nav_bread' >
          <MenuOutlined />
          <a style={{ marginLeft: 5 }} href={'/product/all' + (current_language_ch ? '' : '?lan=en')}>{current_language_ch ? '全部开发板' : 'Hardware'}</a>
          {/* product_line */}
          {(current_product_line && current_product_line !== 'all') && <a style={{ marginLeft: 5 }} href={'/product/' + common_data.url_board_match_set(current_product_line, false) + (current_language_ch ? '' : '?lan=en')}>-&gt;{current_language_ch ? fun.get_chinese_menu(current_product_line) : current_product_line}</a>}
          {/* product_category */}
          {current_product_category && <a style={{ marginLeft: 5 }} href={'/product-' + common_data.url_board_match_set(current_product_line, false) + '/' + current_product_category + (current_language_ch ? '' : '?lan=en')}>-&gt;{current_language_ch ? fun.get_chinese_menu(current_product_category) : current_product_category}</a>}
          {/* cpu_family */}
          {current_cpu_family && <span style={{ marginLeft: 5 }}>-&gt;{current_cpu_family}</span>}
        </div>
      </h3>

      {/* 主表 */}
      <Table
        // scroll={{ y: current_height - 190 }}
        style={{ marginTop: 5, width: '98%', marginLeft: '1%' }} loading={loading} rowKey={'cpu_family'} size='small' pagination={false}
        dataSource={data_show}
        columns={[
          {
            title: 'CPU',
            dataIndex: 'img_path',
            key: 'img_path',
            fixed: 'left',
            width: common_data.isMobile ? 90 : 350,
            render: (img_path: any, data: any) => <div style={{
              minWidth: common_data.isMobile ? 90 : 250,
              textAlign: 'center', boxShadow: '2px 2px 8px 0px rgba(120, 120, 128, 0.36)', borderRadius: 3, paddingTop: 3
            }}>
              <div style={{ display: common_data.isMobile ? 'block' : 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ fontWeight: 'bold', fontSize: common_data.isMobile ? 13 : 16, marginLeft: 3 }}>{data.cpu_family}</div>
                {cookie.load('login_username') && <Button style={{ marginRight: 3, display: 'none' }} type="primary" size="small" onClick={() => {
                  set_loading(true)
                  fun['post_data'](url + 'get_my_info', {}).then(res => {
                    set_loading(false)
                    if (res.status) {
                      console.log(res.result)
                      if ((res.result.is_mainland_China && res.result.company) || (!res.result.is_mainland_China && res.result.company_en) || res.result.company === '恩智浦') {
                        set_visible(true)
                        set_board_set(data.board_set)
                      } else {

                        set_visible_my_info(true)
                        set_my_co_info(res.result)
                      }
                    } else {
                      alert(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
                    }
                  })
                }}>{current_language_ch ? '预定其他时间' : 'Book Another Period'}</Button>}
              </div>

              {/* 开发板图片 */}
              <img style={{ width: '75%', marginTop: 3, marginBottom: 5 }} src={img_path ? (img_path.indexOf('http') === 0 ? img_path : ('https://www.nxp.com.cn/' + img_path)) : product} />

              {/* 功能体验 */}
              {data['function_experience'] && <div style={{ width: '96%', margin: '5px auto 10px' }}>
                <div style={{ fontFamily: 'PoppinsBold', fontWeight: 'bold', fontSize: 15, textAlign: 'left' }}>{current_language_ch ? '功能体验' : 'User Guide'}</div>
                {JSON.parse(data['function_experience']).map((item: any, index: number) => <div className='external_box' style={{ fontSize: 13 }} key={index}>
                  <a target={'_blank'} href={url + (current_language_ch ? item.url_ch : item.url_en)} style={{ color: '#215bd6' }}>{current_language_ch ? item.name_ch : item.name_en}</a>
                </div>)}
              </div>}
            </div>
          },
          {
            title: <div><span>{current_language_ch ? '开发板列表' : 'BOARDS'}</span><Switch style={{ marginLeft: 10 }} checked={show_availab_only} onChange={(e: any) => set_show_availab_only(e)} /><i style={{ marginLeft: 3 }}>{current_language_ch ? '仅显示“可立即使用”' : "Available Now Show Only"}</i></div>,
            dataIndex: 'board_set',
            key: 'board_set',
            render: (board_set: any, record: any, board_index: number) => <div style={{
              // minWidth: 580,
              width: 800,
              overflowY: 'hidden',
              position: 'relative',
              height: record.show_all ? 'auto' : 190,
              // whiteSpace: 'nowrap' 
            }}>

              {/* 循环每一个开发板 */}
              {board_set.map((item: any, index: number) =>
                <div key={index} style={{
                  paddingTop: 20,
                  paddingBottom: 20,
                  margin: '0 10px',
                  display: (item.demo_name || (fun.filter_str(item.name).toUpperCase().indexOf(fun.filter_str(filter_board_name).toUpperCase()) === -1) || (show_availab_only && ((item.claimed_on && (item.claimed_on <= fun.formateTime(new Date()))) || item.lab_state !== 'active'))) ? 'none' : 'inline-block',
                  width: 170, paddingLeft: 10, marginBottom: 20, height: 170,
                  boxSizing: 'border-box',
                  borderLeft: (index > 0 && item.type !== board_set[index - 1]['type']) ? '4px solid #c4c4c4' : '1px solid #dddddd'
                }}>
                  {/* 当前状态 */}
                  {item.lab_state !== 'active' ? <Tag color={'#a5a5a5'}>{current_language_ch ? '维护中' : 'MAINTENANCE'}</Tag> : (item.claimed_on && (item.claimed_on <= fun.formateTime(new Date()))) ? <Tag color={'#f50'}>{current_language_ch ? '正在被使用中' : 'OCCUPIED NOW'}</Tag> :
                    <Tag color={'#69CA00'}>{current_language_ch ? '可立即使用' : 'AVAILABLE NOW'}</Tag>}
                  <b>
                    {!item.demo_name && <i style={{ marginLeft: -5 }}>#{item.num}</i>}
                    {item.screen_haikang_code && <DesktopOutlined style={{ marginLeft: 3 }} />}
                  </b>
                  <br />
                  {/* 开发板名称 */}
                  <a className='nowrap' href={'/details/' + item.format_url_board_name + (current_language_ch ? '' : '?lan=en')} style={{
                    color: '#545454', fontSize: 15, fontWeight: 'bold', fontFamily: 'PoppinsBold',
                    display: 'inline-block',
                    // height: 50
                  }}>{item.demo_name ? item.demo_name : item.name_no_num}</a>

                  {/* 外设 */}
                  <div style={{ marginTop: 5, height: 70, overflow: 'hidden' }}>
                    {item['external_device'] ? <div style={{ height: 48 }}>
                      {item['external_device'].split(';').map((item: any) => <div key={item}>
                        {item.indexOf('screen:') === 0 ? <div className='external_box'>
                          <img src={screen_png} />
                          <span style={{ marginRight: 6, marginLeft: 3, fontSize: 12 }}>{item.replace('screen:', '')}</span>
                        </div> : item.indexOf('camera:') === 0 ? <div className='external_box'>
                          <img src={camera_png} />
                          <span style={{ marginRight: 6, marginLeft: 3, fontSize: 12 }}>{item.replace('camera:', '')}</span>
                        </div> : <div></div>}
                      </div>)}
                    </div> : <div style={{ height: 48 }}></div>}
                    <div style={{ opacity: 0, height: 5, overflow: 'hidden' }}>0</div>
                  </div>
                </div>)}

              {/* 展开折叠按钮 */}
              {board_set.length > 4 && <div onClick={() => {
                let temp: any = [...data_show]
                temp[board_index]['show_all'] = !temp[board_index]['show_all']
                set_data_show(temp)
              }} style={{
                position: 'absolute', left: 20, bottom: 0, fontWeight: 'bold',
                fontFamily: 'PoppinsBold', color: '#215bd6', cursor: 'pointer', fontSize: 15
              }}>{current_language_ch ? (!record.show_all ? '展开' : '收起') : (!record.show_all ? 'More' : 'Less')} {!record.show_all ? <DownOutlined /> : <UpOutlined />}</div>}
            </div>
          },
        ]}
      />
    </div>
  </div>
}

export default App;